import React from 'react';

const Settings = React.createContext({
    _refresh: () => null,
    settings: {}
});

export default Settings;